/* Crochuito – site-wide motion & interactions */
(function () {
  'use strict';
  if (window.CS) return;
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var hasIO = 'IntersectionObserver' in w;
  var vh = w.innerHeight, vw = w.innerWidth;
  de.classList.add('cs-ready');
  if (design) de.classList.add('shopify-design-mode');

  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- split text into animatable words ---------- */
  function split(el) {
    if (el.hasAttribute('data-cs-split-done')) return;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = d.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
            var o = d.createElement('span'); o.className = 'cs-w';
            var inner = d.createElement('span'); inner.className = 'cs-w__i';
            inner.style.setProperty('--wi', i++); inner.textContent = part;
            o.appendChild(inner); frag.appendChild(o);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          if (n.hasAttribute('data-cs-nosplit')) n.style.setProperty('--wi', i++);
          else if (n.tagName !== 'BR') walk(n);
        }
      });
    })(el);
    el.setAttribute('data-cs-split-done', '');
  }

  /* ---------- reveal on scroll ---------- */
  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function observeReveal(scope) {
    $$('[data-cs-split], [data-cs-scrub]', scope).forEach(split);
    $$('[data-cs-reveal], [data-cs-split], [data-cs-observe]', scope).forEach(function (el) {
      if (el.classList.contains('is-visible') || el.closest('[data-cs-wait]')) return;
      if (!io || reduce) el.classList.add('is-visible'); else io.observe(el);
    });
  }

  /* ---------- intro curtain + hero ---------- */
  function liveHero() {
    $$('[data-cs-hero]').forEach(function (h) {
      h.removeAttribute('data-cs-wait');
      h.classList.add('is-live');
      observeReveal(h);
    });
  }
  function initIntro() {
    var intro = d.querySelector('[data-cs-intro]');
    var active = intro && !de.classList.contains('cs-intro-done') && !reduce && !design;
    if (!active) {
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
      de.classList.add('cs-intro-done');
      liveHero();
      return;
    }
    $$('[data-cs-hero]').forEach(function (h) { h.setAttribute('data-cs-wait', ''); });
    var started = false, removed = false;
    function start() { if (started) return; started = true; liveHero(); }
    function remove() {
      if (removed) return; removed = true; start();
      de.classList.add('cs-intro-done');
      if (intro.parentNode) intro.parentNode.removeChild(intro);
    }
    intro.addEventListener('click', function () { de.classList.add('cs-intro-skip'); start(); });
    intro.addEventListener('animationend', function (e) { if (e.target === intro) remove(); });
    setTimeout(start, 1950);
    setTimeout(remove, 4200);
  }

  /* ---------- scroll engine ---------- */
  var bar, parallax = [], scrubs = [], hscrolls = [], stacks = [], makes = [];
  var lastY = w.scrollY, velocity = 0, ticking = false;

  function collect() {
    parallax = $$('[data-cs-speed]');
    scrubs = $$('[data-cs-scrub]').map(function (el) { return { el: el, words: $$('.cs-w__i', el), on: -1 }; });
    hscrolls = $$('[data-cs-hscroll]').map(function (pin) {
      return { pin: pin, track: pin.querySelector('[data-cs-track]'), viewport: pin.querySelector('[data-cs-viewport]'), dist: 0 };
    }).filter(function (h) { return h.track && h.viewport; });
    stacks = $$('[data-cs-stack]');
    makes = $$('.cs-make');
    measure();
  }

  function measure() {
    vh = w.innerHeight; vw = w.innerWidth;
    hscrolls.forEach(function (h) {
      var pinned = vw >= 990 && !reduce && !design;
      h.pin.classList.toggle('is-pinned', pinned);
      if (!pinned) { h.pin.style.height = ''; h.track.style.transform = ''; h.dist = 0; return; }
      h.dist = Math.max(0, h.track.scrollWidth - h.viewport.clientWidth);
      h.pin.style.height = (h.dist + vh) + 'px';
    });
    var f = d.querySelector('body > footer');
    if (f) de.classList.toggle('cs-footer-reveal', vw >= 750 && f.offsetHeight > 0 && f.offsetHeight < vh * 0.92);
    requestTick();
  }

  function update() {
    ticking = false;
    var y = w.scrollY;
    velocity = y - lastY; lastY = y;
    var max = de.scrollHeight - vh;
    if (bar) bar.style.setProperty('--cs-p', max > 0 ? (y / max).toFixed(4) : 0);
    if (reduce) return;
    var i, r;
    for (i = 0; i < parallax.length; i++) {
      var el = parallax[i];
      r = el.getBoundingClientRect();
      var prev = el._py || 0, top = r.top - prev;
      if (top + r.height < -300 || top > vh + 300) continue;
      var speed = parseFloat(el.getAttribute('data-cs-speed')) || 0.1;
      var py = -((top + r.height / 2) - vh / 2) * speed;
      el._py = py;
      el.style.setProperty('--cs-py', py.toFixed(1) + 'px');
    }
    scrubs.forEach(function (s) {
      r = s.el.getBoundingClientRect();
      var start = vh * 0.88, end = vh * 0.42;
      var p = clamp((start - r.top) / (r.height + start - end), 0, 1);
      var n = Math.round(p * s.words.length);
      if (n !== s.on) { s.words.forEach(function (wd, k) { wd.classList.toggle('is-on', k < n); }); s.on = n; }
    });
    hscrolls.forEach(function (h) {
      if (!h.dist) return;
      r = h.pin.getBoundingClientRect();
      var p = clamp(-r.top / h.dist, 0, 1);
      h.track.style.transform = 'translate3d(' + (-p * h.dist).toFixed(1) + 'px,0,0)';
      h.pin.style.setProperty('--cs-hp', p.toFixed(4));
    });
    for (i = 0; i < stacks.length - 1; i++) {
      var a = stacks[i].getBoundingClientRect(), b = stacks[i + 1].getBoundingClientRect();
      var cover = clamp((a.top + stacks[i].offsetHeight - b.top) / stacks[i].offsetHeight, 0, 1);
      stacks[i].style.setProperty('--cs-cover', cover.toFixed(3));
    }
    makes.forEach(function (m) {
      var steps = m.querySelector('.cs-make__steps');
      if (!steps) return;
      r = steps.getBoundingClientRect();
      m.style.setProperty('--cs-mp', clamp((vh * 0.5 - r.top) / r.height, 0, 1).toFixed(3));
    });
  }
  function requestTick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* ---------- making-of: active step ---------- */
  function initMaking(scope) {
    $$('.cs-make', scope).forEach(function (sec) {
      if (sec._mk) return; sec._mk = 1;
      var steps = $$('.cs-step', sec), frames = $$('.cs-make__frame', sec), count = sec.querySelector('[data-cs-count]');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
        if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
      }
      activate(0);
      if (!hasIO) return;
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { o.observe(s); });
    });
  }

  /* ---------- marquee reacting to scroll speed ---------- */
  function initMarquee(scope) {
    $$('[data-cs-marquee]', scope).forEach(function (m) {
      if (m._mq || reduce) return; m._mq = 1;
      var track = m.querySelector('.cs-marquee__track'), group = track && track.firstElementChild;
      if (!group || !hasIO) return;
      var x = 0, dir = 1, mv = 0, visible = false, raf = 0, gw = group.getBoundingClientRect().width;
      var base = parseFloat(m.getAttribute('data-speed')) || 1;
      w.addEventListener('resize', function () { gw = group.getBoundingClientRect().width; });
      function step() {
        if (!visible) { raf = 0; return; }
        mv += (velocity - mv) * 0.12; velocity *= 0.9;
        if (mv > 0.4) dir = 1; else if (mv < -0.4) dir = -1;
        x -= (base * 0.7 + Math.min(Math.abs(mv) * 0.35, 16)) * dir;
        if (x <= -gw) x += gw;
        if (x > 0) x -= gw;
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        raf = requestAnimationFrame(step);
      }
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible && !raf) raf = requestAnimationFrame(step);
      }).observe(m);
    });
  }

  /* ---------- pointer effects: cursor, magnetic, tilt, hero depth ---------- */
  var cursor;
  function initCursor() {
    if (!fine || reduce || cursor) return;
    cursor = d.createElement('div'); cursor.className = 'cs-cursor'; cursor.setAttribute('aria-hidden', 'true');
    d.body.appendChild(cursor);
    var tx = -200, ty = -200, cx = -200, cy = -200, running = false, label = '';
    function loop() {
      cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2;
      cursor.style.translate = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
      if (Math.abs(tx - cx) > 0.2 || Math.abs(ty - cy) > 0.2) requestAnimationFrame(loop); else running = false;
    }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, { passive: true });
    d.addEventListener('pointerover', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-cs-cursor]') : null;
      if (t && !(e.target.closest('.cs-card__form'))) {
        var l = t.getAttribute('data-cs-cursor');
        if (l !== label) { cursor.textContent = l; label = l; }
        cursor.classList.add('is-active');
      } else cursor.classList.remove('is-active');
    });
    de.addEventListener('mouseleave', function () { cursor.classList.remove('is-active'); });
  }
  function initPointer(scope) {
    if (!fine || reduce) return;
    $$('[data-cs-magnetic]', scope).forEach(function (el) {
      if (el._mag) return; el._mag = 1;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.translate = ((e.clientX - r.left - r.width / 2) * 0.25).toFixed(1) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.35).toFixed(1) + 'px';
      });
      el.addEventListener('pointerleave', function () { el.style.translate = ''; });
    });
    $$('.cs-card', scope).forEach(function (card) {
      if (card._tilt) return; card._tilt = 1;
      var media = card.querySelector('.cs-card__media');
      if (!media) return;
      card.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        media.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 7).toFixed(2) + 'deg');
        media.style.setProperty('--rx', (-((e.clientY - r.top) / r.height - 0.5) * 7).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () { media.style.setProperty('--rx', '0deg'); media.style.setProperty('--ry', '0deg'); });
    });
    $$('[data-cs-hero]', scope).forEach(function (hero) {
      if (hero._depth) return; hero._depth = 1;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * 44).toFixed(1) + 'px');
        hero.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * 44).toFixed(1) + 'px');
      });
      hero.addEventListener('pointerleave', function () { hero.style.setProperty('--mx', '0px'); hero.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg, withLink) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'cs-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = '';
    var s = d.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (withLink) { var a = d.createElement('a'); a.href = root + 'cart'; a.textContent = 'View basket'; toastEl.appendChild(a); }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* ---------- add to basket without leaving the page ---------- */
  function setLabel(btn, state) {
    var l = btn.querySelector('[data-cs-add-label]');
    if (!l) return;
    if (!l.hasAttribute('data-orig')) l.setAttribute('data-orig', l.textContent);
    l.textContent = state === 'added' ? (btn.getAttribute('data-label-added') || 'Added') : l.getAttribute('data-orig');
  }
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-cs-add]')) return;
    e.preventDefault();
    var btns = [e.submitter, form.querySelector('[type="submit"]')];
    if (form.id) btns = btns.concat($$('[type="submit"][form="' + form.id + '"]'));
    btns = btns.filter(function (b, k) { return b && btns.indexOf(b) === k; });
    btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    var done = function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); };
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); })
      .then(function (item) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { return { item: item, cart: cart }; });
      })
      .then(function (res) {
        done();
        d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res.cart, sourceId: 'cs-add', data: { itemCount: res.cart.item_count, source: 'cs-add' } } }));
        btns.forEach(function (b) {
          b.classList.add('is-added'); setLabel(b, 'added');
          setTimeout(function () { b.classList.remove('is-added'); setLabel(b, 'reset'); }, 2200);
        });
        var drawer = d.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); }, 380);
        else toast((res.item && res.item.product_title ? res.item.product_title : 'Your friend') + ' is in your basket', true);
      })
      .catch(function (err) { done(); toast(err && err.message ? err.message : 'Could not add this item', false); });
  });

  /* ---------- product page ---------- */
  function initPDP(scope) {
    $$('[data-cs-product]', scope).forEach(function (sec) {
      if (sec._pdp) return; sec._pdp = 1;
      var slides = $$('.cs-pdp__slide', sec), thumbs = $$('.cs-pdp__thumb', sec), counter = sec.querySelector('[data-cs-current]');
      function setActive(i) {
        if (i < 0) return;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (counter) counter.textContent = i + 1;
      }
      function goTo(k) {
        var s = slides[k]; if (!s) return;
        if (vw < 990) s.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
        else s.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      if (hasIO && slides.length > 1) {
        var sio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
        }, { threshold: 0.6 });
        slides.forEach(function (s) { sio.observe(s); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setActive(k); goTo(k); }); });
      if (fine) slides.forEach(function (s) {
        function pos(e) {
          var r = s.getBoundingClientRect();
          s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        }
        s.addEventListener('click', function (e) { if (vw < 990) return; pos(e); s.classList.toggle('is-zoomed'); });
        s.addEventListener('pointermove', function (e) { if (s.classList.contains('is-zoomed')) pos(e); });
        s.addEventListener('pointerleave', function () { s.classList.remove('is-zoomed'); });
      });

      var variants = [];
      var dataEl = sec.querySelector('[data-cs-variants]');
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
      var idInput = sec.querySelector('[data-cs-variant-id]'), priceEl = sec.querySelector('[data-cs-price]');
      var addBtns = $$('[data-cs-add-btn]', sec), barPrice = sec.querySelector('[data-cs-bar-price]');
      var groups = $$('[data-cs-opt-group]', sec);
      function selected() { return groups.map(function (g) { var b = g.querySelector('[aria-pressed="true"]'); return b ? b.getAttribute('data-value') : null; }); }
      function match(sel) {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k], ok = true;
          for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function marks() {
        groups.forEach(function (g, gi) {
          $$('.cs-opt', g).forEach(function (b) {
            var sel = selected(); sel[gi] = b.getAttribute('data-value');
            var m = match(sel);
            b.classList.toggle('is-unavailable', !m || !m.available);
          });
        });
      }
      function apply(v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.textContent = v.price;
          if (v.compare) { var s = d.createElement('s'); s.textContent = v.compare; priceEl.appendChild(s); }
        }
        if (barPrice) barPrice.textContent = v.price;
        addBtns.forEach(function (btn) {
          btn.disabled = !v.available;
          var l = btn.querySelector('[data-cs-add-label]');
          if (l) { l.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout'); l.removeAttribute('data-orig'); }
        });
        marks();
        if (v.media) {
          var idx = -1;
          slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(v.media)) idx = k; });
          if (idx > -1) { setActive(idx); goTo(idx); }
        }
        try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (err) {}
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('.cs-opt'); if (!b) return;
          $$('.cs-opt', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var v = match(selected()); if (v) apply(v);
        });
      });
      if (groups.length) marks();

      $$('[data-cs-qty]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentNode.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-cs-qty'), 10));
        });
      });

      var barEl = sec.querySelector('[data-cs-bar]'), main = sec.querySelector('.cs-pdp__add');
      if (barEl && main && hasIO) new IntersectionObserver(function (es) {
        var e = es[0];
        barEl.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(main);
    });
  }

  /* ---------- smooth accordions ---------- */
  function initAcc(scope) {
    $$('.cs-acc details', scope).forEach(function (det) {
      if (det._acc) return; det._acc = 1;
      var sum = det.querySelector('summary');
      if (!sum) return;
      sum.addEventListener('click', function (e) {
        if (reduce || !det.animate) return;
        e.preventDefault();
        if (det._anim) { det._anim.cancel(); det._anim = null; }
        var start = det.offsetHeight, opts = { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' };
        if (!det.open) {
          det.open = true;
          var end = det.offsetHeight;
          det._anim = det.animate({ height: [start + 'px', end + 'px'] }, opts);
          det._anim.onfinish = function () { det._anim = null; };
        } else {
          var closed = sum.offsetHeight + (det.offsetHeight - det.clientHeight);
          det._anim = det.animate({ height: [start + 'px', closed + 'px'] }, opts);
          det._anim.onfinish = function () { det.open = false; det._anim = null; };
        }
      });
    });
  }

  /* ---------- horizontal rails (drag + arrows) and mobile gallery progress ---------- */
  function initRails(scope) {
    $$('[data-cs-railx]', scope).forEach(function (rail) {
      if (rail._r) return; rail._r = 1;
      var nav = rail.id ? d.querySelector('[data-cs-railnav="' + rail.id + '"]') : null;
      if (nav) $$('button', nav).forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: (b.getAttribute('data-dir') === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      if (!fine) return;
      var down = false, moved = false, sx = 0, sl = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
      w.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); }
        if (moved) rail.scrollLeft = sl - dx;
      });
      w.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { rail.classList.remove('is-dragging'); }, 30); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
    $$('[data-cs-hscroll]', scope).forEach(function (pin) {
      var vp = pin.querySelector('[data-cs-viewport]');
      if (!vp || vp._sp) return; vp._sp = 1;
      vp.addEventListener('scroll', function () {
        if (pin.classList.contains('is-pinned')) return;
        var m = vp.scrollWidth - vp.clientWidth;
        pin.style.setProperty('--cs-hp', m > 0 ? (vp.scrollLeft / m).toFixed(4) : 0);
      }, { passive: true });
    });
  }

  /* ---------- chapter dots (long pages) ---------- */
  var chapterIO;
  function initChapters() {
    var old = d.querySelector('.cs-rail'); if (old) old.remove();
    var chapters = $$('[data-cs-chapter]').filter(function (c) { return c.id; });
    if (chapters.length < 4 || !hasIO) return;
    var rail = d.createElement('nav'); rail.className = 'cs-rail'; rail.setAttribute('aria-label', 'Page chapters');
    chapters.forEach(function (c) {
      var a = d.createElement('a'); a.href = '#' + c.id; a.innerHTML = '<span></span><i></i>';
      a.querySelector('span').textContent = c.getAttribute('data-cs-chapter');
      a.addEventListener('click', function (ev) { ev.preventDefault(); c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); });
      rail.appendChild(a);
    });
    d.body.appendChild(rail);
    var links = $$('a', rail);
    if (chapterIO) chapterIO.disconnect();
    chapterIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = chapters.indexOf(e.target);
        links.forEach(function (l, j) { l.classList.toggle('is-active', j === i); });
        rail.classList.toggle('is-on', i > 0);
      });
    }, { rootMargin: '-50% 0px -50% 0px' });
    chapters.forEach(function (c) { chapterIO.observe(c); });
  }

  /* ---------- boot ---------- */
  function init(scope) {
    scope = scope || d;
    initMaking(scope); initMarquee(scope); initPointer(scope); initPDP(scope); initAcc(scope); initRails(scope);
    observeReveal(scope);
    collect();
  }
  function boot() {
    bar = d.createElement('div'); bar.className = 'cs-progress'; bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    initIntro();
    init(d);
    initCursor();
    initChapters();
    update();
  }
  w.CS = { refresh: function (scope) { init(scope || d); initChapters(); } };
  w.addEventListener('scroll', requestTick, { passive: true });
  w.addEventListener('resize', function () { measure(); });
  w.addEventListener('load', function () { measure(); });
  w.addEventListener('pageshow', function (e) { if (e.persisted) measure(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); initChapters(); });
  d.addEventListener('shopify:section:unload', function () { setTimeout(function () { collect(); initChapters(); }, 60); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
